import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import PrimaryButtonComponent from '../../../Components/Buttons/PrimaryButton/PrimaryButton.component';
import { FormContainer } from '../../../AdminRoutes/CreateRoutes/CreateForm.styles';
import BreadCrumbs from '../../../Components/Breadcrumbs/BreadcrumbsComponent.component';
import { httpCreateForms } from '../../../Hooks/company/company.post.hooks';
import AuthCheckManager from '../../../Utils/AuthCheck/ManagerCheck.auth';
import HelmetHelper from '../../../Components/PageHelmet/HelmetHelper.component';

const UploadForms = () => {
  const { id: companyId } = useParams();
  const [files, setFiles] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);
  const [status, setStatus] = useState('');

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setFiles(selectedFiles);
    const previews = selectedFiles.map((file) => URL.createObjectURL(file));
    setPreviewUrls(previews);
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    const formData = new FormData();

    files.forEach((file) => {
      const formattedFileName = formatFileName(
        file.name.replace(/\.pdf$/i, '').replace(/_/g, ' ')
      );
      const renamedFile = new File([file], `${formattedFileName}.pdf`, {
        type: file.type,
      });

      formData.append('attachments', renamedFile);
    });

    try {
      setStatus('Uploading...');
      const response = await httpCreateForms(companyId, formData);
      const data = await response.json();
      if (response.ok) {
        setStatus(data.msg || 'Forms have been successfully uploaded');
        setFiles([]);
        setPreviewUrls([]);
      } else {
        console.error(data.msg);
        setStatus(data.msg || 'Error uploading forms');
        return;
      }
    } catch (err) {
      console.error('Error uploading files:', err);
      setStatus('Error uploading files');
      return;
    }
  };

  const handleDeleteLocalFile = (index) => {
    // Remove the file and its preview URL by index
    setFiles((prevFiles) => prevFiles?.filter((_, i) => i !== index));
    setPreviewUrls((prevUrls) => prevUrls?.filter((_, i) => i !== index));
  };

  const formatFileName = (fileName) => {
    return fileName
      ?.split(' ') // Split the file name into words
      ?.map(
        (word) => word?.charAt(0)?.toUpperCase() + word?.slice(1)?.toLowerCase()
      ) // Capitalize the first letter of each word
      ?.join(' '); // Join the words back together
  };

  return (
    <>
      <AuthCheckManager>
        <HelmetHelper
          title="Upload Forms"
          description="Upload forms for company"
        />
        <FormContainer>
          <BreadCrumbs
            one="Company Dashboard"
            oneLink="/company"
            two="Upload Forms"
          />
          <h2>Upload Forms</h2>
          <form>
            <input type="file" multiple onChange={handleFileChange} />
            <PrimaryButtonComponent functionName={handleUpload} span="Upload" />
            <h4>Preview</h4>
            <div>
              {previewUrls.map((url, index) => (
                <div key={index}>
                  <a href={url} target="_blank" rel="noopener noreferrer">
                    Preview {files[index]?.name}
                  </a>
                  <button
                    type="button"
                    onClick={() => handleDeleteLocalFile(index)}
                  >
                    Remove
                  </button>
                </div>
              ))}
            </div>
            <p>Status: {status}</p>
          </form>
        </FormContainer>
      </AuthCheckManager>
    </>
  );
};

export default UploadForms;
